import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export async function verifyCertificate(certificateId) {
  const { data } = await api.post("/verify", { certificate_id: certificateId });
  return data;
}

export async function submitDemoRequest(payload) {
  const { data } = await api.post("/demo-request", payload);
  return data;
}
